import { API_BASE_URL } from "../config";

const BASE_URL = API_BASE_URL;

export async function getHome() {
  const res = await fetch(`${BASE_URL}/home`);
  return res.json();
}

export async function getHero() {
  const res = await fetch(`${BASE_URL}/hero`);
  return res.json();
}

export async function getHeader() {
  const res = await fetch(`${BASE_URL}/header`);
  return res.json();
}

export async function getFooter() {
  const res = await fetch(`${BASE_URL}/footer`);
  return res.json();
}

// Product Page (Hero + CTA)
export async function getProductPage(slug) {
  const res = await fetch(`${BASE_URL}/product-page/${slug}`);
  return res.json();
}

// Products List
export async function getProducts(slug) {
  const res = await fetch(`${BASE_URL}/products/${slug}`);
  return res.json();
}
export async function getFacility() {
  const res = await fetch(`${BASE_URL}/facility`);
  return res.json();
}
export async function getCertificates() {
  const res = await fetch(`${BASE_URL}/certificates`);

  if (!res.ok) {
    throw new Error("Failed to fetch certificates");
  }

  return res.json();
}
export async function getPatientSupport() {
  const res = await fetch(`${BASE_URL}/patient-support`);

  if (!res.ok) {
    throw new Error("Failed to fetch Patient Support");
  }

  return res.json();
}
export async function getCareer() {
  const res = await fetch(`${BASE_URL}/career`);

  if (!res.ok) {
    throw new Error("Failed to fetch Career page");
  }

  return res.json();
}
export async function getContactUs() {
  const res = await fetch(`${BASE_URL}/contact-us`);

  if (!res.ok) {
    throw new Error("Failed to fetch Contact Us page");
  }

  return res.json();
}
export async function getPage(slug) {
  const res = await fetch(`${BASE_URL}/page/${slug}`);

  if (!res.ok) {
    throw new Error("Failed to fetch page");
  }

  return res.json();
}